import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchBeginPlaceOrder, SetECheck, UpdateCart } from "@insite/client-framework/Store/Pages/OnePageCheckout/Handlers/PlaceOrder";
import { CustomAdditionalOrderInfoState } from "@electricMotorShop/Store/AdditionalOrderInfomationReducer";

// XC Customization to add the additionalOrderEmail to the cart.properties

type PlaceOrderProps = Parameters<typeof DispatchBeginPlaceOrder>[0];

const DELIVERY_ADDITIONAL_ORDER_EMAIL = "DeliveryAdditionalOrderEmail"

function SetAdditionalOrderInfo(props: PlaceOrderProps){
    const state = props.getState() as CustomAdditionalOrderInfoState;    
    props.cartToUpdate.properties[DELIVERY_ADDITIONAL_ORDER_EMAIL] = state.additionalOrderInfoState.additionalOrderEmail ?? "";
    props.cartToUpdate = {
        ...props.cartToUpdate,
    };
}

function ClearAdditionalOrderInfoState(props: PlaceOrderProps){
    props.dispatch({
        type: "Custom/AdditionalOrderInfo/ClearAdditionalOrderInfo",
    });
};

addToChainAfter(chain, SetECheck, SetAdditionalOrderInfo);
addToChainAfter(chain, UpdateCart,ClearAdditionalOrderInfoState)
